export default __webpack_public_path__ + "static/media/home-restaurant-img-13.f12ed2ed.jpg";